import { render, staticRenderFns } from "./management-library-access-restriction-form.vue?vue&type=template&id=8c0f66b8"
import script from "./management-library-access-restriction-form.vue?vue&type=script&lang=js"
export * from "./management-library-access-restriction-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports